import { ArrowRight, Check } from 'lucide-react';
import { PageMotion } from 'src/components/layout/page-motion.tsx';
import { SECTIONS } from 'src/data/sections.ts';

import { BackButton } from './back-button.tsx';
import { Eyebrow } from './eyebrow.tsx';
import { PrimaryButton } from './primary-button.tsx';

export function SectionTransition({
  fromIdx,
  onContinue,
  onBack
}: {
  fromIdx: number;
  onContinue: () => void;
  onBack: () => void;
}) {
  const done = SECTIONS[fromIdx];
  const next = SECTIONS[fromIdx + 1];
  const NextIcon = next.icon;
  return (
    <PageMotion>
      <div className="mx-auto max-w-2xl px-5 lg:px-10 py-16 lg:py-24 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-zeb-success-surface flex items-center justify-center shadow-zeb-xs">
          <Check className="h-5 w-5 text-zeb-success" />
        </div>
        <Eyebrow size="body" className="mt-6">
          Sektion {fromIdx + 1} von 3 abgeschlossen
        </Eyebrow>
        <h2
          className="mt-4 text-title-lg sm:text-heading-lg leading-tight tracking-tight text-zeb-tertiary"
          style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, letterSpacing: '-0.02em' }}>
          {done.title} – geschafft.
        </h2>
        <p
          className="mt-5 mx-auto max-w-md text-body-sm leading-relaxed text-zeb-gray-600"
          style={{ fontFamily: 'var(--font-body)', fontWeight: 500 }}>
          Weiter geht es mit der nächsten Ebene des zeb-Frameworks.
        </p>

        <div className="mt-10 mx-auto max-w-md rounded-md border border-zeb-muted bg-white p-5 text-left flex items-start gap-4 shadow-zeb-sm">
          <NextIcon className="h-5 w-5 text-zeb-primary mt-0.5 shrink-0" />
          <div className="min-w-0">
            <div className="text-note font-medium tracking-normal text-zeb-primary">
              Als Nächstes · {next.kicker}
            </div>
            <div
              className="mt-1 text-body-lg text-zeb-tertiary"
              style={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 700,
                letterSpacing: '-0.02em'
              }}>
              {next.title}
            </div>
            <div className="mt-1 text-sm text-zeb-gray-600">{next.intro}</div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center gap-5">
          <PrimaryButton onClick={onContinue}>
            Weiter mit {next.title.split(' der ')[0]} <ArrowRight className="ml-2 h-4 w-4" />
          </PrimaryButton>
          <BackButton onClick={onBack} />
        </div>
      </div>
    </PageMotion>
  );
}
